import {Module} from "vuex";
import APIClient from "@/service/APIClient";
import CurrencyCompareItemDTO from "@/models/CurrencyCompareItemDTO";
import RateSourceDTO from "@/models/RateSourceDTO";
import {Dictionary} from "@/types";

const api = new APIClient();

const rateSources: Module<any, any> = {
    namespaced: true,
    state: {
        rateSources: {} as Dictionary<RateSourceDTO>,
        systemSources: [] as string[],
        withCustomSources: [] as RateSourceDTO[],
        compareList: [] as CurrencyCompareItemDTO[]
    },
    actions: {
        async loadList ({ commit }) {
            const rateSources = await api.rateSourcesAll();

            commit('SET_LIST', {
                rateSources,
            });
        },
        async loadSystemList ({ commit }) {
            commit('SET_SYSTEM_LIST', await api.rateSources());
        },
        async loadWithCustomList ({ commit }) {
            commit('SET_WITH_CUSTOM_LIST', await api.rateSourcesWithCustom());
        },
        async addToCompareList ({ commit }, item: CurrencyCompareItemDTO) {
            commit('addItemToCompareList', item);
        },
        async removeFromCompareList ({ commit }, index: number) {
            commit('removeFromCompareList', index);
        },
    },
    mutations: {
        SET_LIST: (state, payload: any) => {
            const sources = {} as Dictionary<RateSourceDTO>
            for (const item of payload.rateSources) {
                sources[item.source] = item
            }
            state.rateSources = sources;
        },
        SET_SYSTEM_LIST: (state, sources: string[]) => {
            state.systemSources = sources;
        },
        SET_WITH_CUSTOM_LIST: (state, sources: RateSourceDTO[]) => {
            state.withCustomSources = sources;
        },
        addItemToCompareList: (state, item: CurrencyCompareItemDTO) => {
            state.compareList.push(item)
        },
        removeFromCompareList: (state, index: number) => {
            if (index >= 0 && index < state.compareList.length) {
                state.compareList.splice(index, 1)
            }
        },
    },
    getters: {
        all: (state): string[] => Object.values(state.rateSources).map(item=> (item as RateSourceDTO).source),
        get: (state) => (source: string): RateSourceDTO|null => {
            return state.rateSources[source] ?? null
        },
        systemSources: (state): string[] => state.systemSources,
        withCustomSources: (state): RateSourceDTO[] => state.withCustomSources,
        compareList: (state): CurrencyCompareItemDTO[] => state.compareList,
    }
}

export default rateSources;
